import { SepaFilterI } from 'src/adminPanel/components/pages/offsetting/SepaFilter';
import { PageableQueryParams } from 'src/entities/basic-types/Pageable';
import { action } from '../actions';

// SEPA Payments
export const FETCH_SEPA_PAYMENTS = 'FETCH_SEPA_PAYMENTS';
export const REQUEST_SEPA_PAYMENTS = 'REQUEST_SEPA_PAYMENTS';
export const SUCCESS_SEPA_PAYMENTS = 'SUCCESS_SEPA_PAYMENTS';
export const FAILURE_SEPA_PAYMENTS = 'FAIL_SEPA_PAYMENTS';

export const fetchSepaPayments = (pageable?: PageableQueryParams, filter?: SepaFilterI) =>
    action(FETCH_SEPA_PAYMENTS, { pageable, filter });
export const requestSepaPayments = () => action(REQUEST_SEPA_PAYMENTS);
export const requestSepaPaymentsSuccess = (response: any) => action(SUCCESS_SEPA_PAYMENTS, { response });
export const requestSepaPaymentsFailure = (error: any) => action(FAILURE_SEPA_PAYMENTS, { error });

// SEPA Payment Details
export const FETCH_SEPA_PAYMENT_DETAILS = 'FETCH_SEPA_PAYMENT_DETAILS';
export const REQUEST_SEPA_PAYMENT_DETAILS = 'REQUEST_SEPA_PAYMENT_DETAILS';
export const SUCCESS_SEPA_PAYMENT_DETAILS = 'SUCCESS_SEPA_PAYMENT_DETAILS';
export const FAILURE_SEPA_PAYMENT_DETAILS = 'FAILURE_SEPA_PAYMENT_DETAILS';

export const fetchSepaPaymentDetails = (externalOrderId: string) =>
    action(FETCH_SEPA_PAYMENT_DETAILS, { externalOrderId });
export const requestSepaPaymentDetails = () => action(REQUEST_SEPA_PAYMENT_DETAILS);
export const requestSepaPaymentDetailsSuccess = (response: any) => action(SUCCESS_SEPA_PAYMENT_DETAILS, { response });
export const requestSepaPaymentDetailsFailure = (error: any) => action(FAILURE_SEPA_PAYMENT_DETAILS, { error });
